import { unionBy } from 'lodash';

import { getItem, setItem } from '../local_storage_utils';

interface ILoggedOutUserAction {
  name: loggedOutUserActionNames;
  created: number;
}

export enum loggedOutUserActionNames {
  VIEWED_SELLER_OPEN_TO_OFFERS_CALLOUT = 'VIEWED_SELLER_OPEN_TO_OFFERS_CALLOUT_V2',
}

const LOGGED_OUT_USER_ACTIONS_KEY = 'LOGGED_OUT_USER_ACTIONS';

export function getLoggedOutUserActions() {
  return getItem(LOGGED_OUT_USER_ACTIONS_KEY) || [];
}

export function setLoggedOutUserActions(value: ILoggedOutUserAction) {
  setItem(LOGGED_OUT_USER_ACTIONS_KEY,
    unionBy([value], getLoggedOutUserActions(), 'name'),
  );
}
